import React, { FC } from 'react';
import Image from './image';
import ImageHeroAsset from './imageHeroAsset';
import { THeroBannerSeriesDetailMediaImage } from '../types/productHeroBannerSeriesDetail.types';

const Media: FC<THeroBannerSeriesDetailMediaImage> = (props) => {
  const { model } = props;

  if (model.assetHero) {
    return <ImageHeroAsset model={model} />;
  } else {
    return <Image model={model} />;
  }
};

export default Media;